import React from 'react';
import { infoPurpleIcon } from '../../../../assets/hostedassets';
import Tooltip from '../../../../common/_custom/Tooltip/Tooltip';
import styles from './GstOverview.module.scss';

interface SignatoriesPillProps {
    signatories: string[];
}

function SignatoriesPill({ signatories }: Readonly<SignatoriesPillProps>) {
    if (!signatories || signatories.length === 0) return null;

    const hoverContent = (
        <ul className={styles.SignatoriesList}>
            {signatories.map((name, index) => (
                <li className={styles.SignatoriesListItem} key={`${name}-${index}`}>
                    {name}
                </li>
            ))}
        </ul>
    );

    return (
        <Tooltip content={hoverContent} direction="bottom" usePortal fitContent>
            <div className={styles.SignatoriesPill} role="button" tabIndex={0}>
                <span>
                    {signatories.length} {signatories.length === 1 ? 'Signatory' : 'Signatories'}
                </span>
                <img className={styles.SignatoriesPillIcon} src={infoPurpleIcon} alt="" aria-hidden />
            </div>
        </Tooltip>
    );
}

export default SignatoriesPill;
